/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiBridgeRecipientMappingConf,
    InternalApiBridgeRecipientMappingConfFromJSON,
    InternalApiBridgeRecipientMappingConfToJSON,
    InternalApiBridgeRecipientMappingUpdateRequest,
    InternalApiBridgeRecipientMappingUpdateRequestFromJSON,
    InternalApiBridgeRecipientMappingUpdateRequestToJSON,
    InternalApiBridgeSettings,
    InternalApiBridgeSettingsFromJSON,
    InternalApiBridgeSettingsToJSON,
} from '../models';

export interface ChangeBridgeSettingsRequest {
    internalApiBridgeSettings: InternalApiBridgeSettings;
}

export interface UpdateBridgeRecipientMappingConfigurationRequest {
    internalApiBridgeRecipientMappingUpdateRequest: InternalApiBridgeRecipientMappingUpdateRequest;
}

/**
 * 
 */
export class BridgeSettingsApi extends runtime.BaseAPI {

    /**
     * Change bridge settings
     */
    async changeBridgeSettingsRaw(requestParameters: ChangeBridgeSettingsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiBridgeSettings>> {
        if (requestParameters.internalApiBridgeSettings === null || requestParameters.internalApiBridgeSettings === undefined) {
            throw new runtime.RequiredError('internalApiBridgeSettings','Required parameter requestParameters.internalApiBridgeSettings was null or undefined when calling changeBridgeSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/bridge-settings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiBridgeSettingsToJSON(requestParameters.internalApiBridgeSettings),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiBridgeSettingsFromJSON(jsonValue));
    }

    /**
     * Change bridge settings
     */
    async changeBridgeSettings(requestParameters: ChangeBridgeSettingsRequest, initOverrides?: RequestInit): Promise<InternalApiBridgeSettings> {
        const response = await this.changeBridgeSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get bridge settings confs
     */
    async getBridgeRecipientMappingConfsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiBridgeRecipientMappingConf>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/bridge-settings/confs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiBridgeRecipientMappingConfFromJSON));
    }

    /**
     * Get bridge settings confs
     */
    async getBridgeRecipientMappingConfs(initOverrides?: RequestInit): Promise<Array<InternalApiBridgeRecipientMappingConf>> {
        const response = await this.getBridgeRecipientMappingConfsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get bridge settings
     */
    async getBridgeSettingsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiBridgeSettings>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/bridge-settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiBridgeSettingsFromJSON(jsonValue));
    }

    /**
     * Get bridge settings
     */
    async getBridgeSettings(initOverrides?: RequestInit): Promise<InternalApiBridgeSettings> {
        const response = await this.getBridgeSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update bridge recipient mapping configuration
     */
    async updateBridgeRecipientMappingConfigurationRaw(requestParameters: UpdateBridgeRecipientMappingConfigurationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiBridgeRecipientMappingConf>>> {
        if (requestParameters.internalApiBridgeRecipientMappingUpdateRequest === null || requestParameters.internalApiBridgeRecipientMappingUpdateRequest === undefined) {
            throw new runtime.RequiredError('internalApiBridgeRecipientMappingUpdateRequest','Required parameter requestParameters.internalApiBridgeRecipientMappingUpdateRequest was null or undefined when calling updateBridgeRecipientMappingConfiguration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/bridge-settings/confs`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiBridgeRecipientMappingUpdateRequestToJSON(requestParameters.internalApiBridgeRecipientMappingUpdateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiBridgeRecipientMappingConfFromJSON));
    }

    /**
     * Update bridge recipient mapping configuration
     */
    async updateBridgeRecipientMappingConfiguration(requestParameters: UpdateBridgeRecipientMappingConfigurationRequest, initOverrides?: RequestInit): Promise<Array<InternalApiBridgeRecipientMappingConf>> {
        const response = await this.updateBridgeRecipientMappingConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
